import React from 'react'
import styles from './style.module.less'

export default function Icon(props) {
  const { icon, text, style = {} } = props
  const iconStyle = {
    backgroundImage: `url(${icon})`,
    fontSize: '18px'
  }
  return (
    <div className={styles.wrapper} style={style}>
      <div className={styles.icon} style={iconStyle} />
      <div className={styles.text}>{text}</div>
    </div>
  )
}
